export enum ProductContentTabs {
  FEATURES = 'FEATURES',
  IMAGE_GALLERY = 'IMAGE GALLERY',
  DOWNLOADS = 'DOWNLOADS'
}
